var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgThumbsUp = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M18.28,22.7501772 L4,22.7501772 C2.48121694,22.7501772 1.25,21.5187831 1.25,20 L1.25,13 C1.25,11.4812169 2.48121694,10.25 4,10.25 L6.51259518,10.25 L10.3146413,1.69539615 C10.4350173,1.42455014 10.7036085,1.25 11,1.25 C13.0710678,1.25 14.75,2.92893219 14.75,5 L14.75,8.25 L19.6515072,8.25004809 C20.4582908,8.2409117 21.2283845,8.58653791 21.7578127,9.1953803 C22.2872408,9.80422269 22.5225842,10.6148492 22.4013358,11.4136715 L21.0215218,20.4124521 C20.8159059,21.7683067 19.642791,22.7654543 18.28,22.7501772 Z M6.25,21.25 L6.25,11.75 L4,11.75 C3.30964406,11.75 2.75,12.3096441 2.75,13 L2.75,20 C2.75,20.6903559 3.30964406,21.25 4,21.25 L6.25,21.25 L6.25,21.25 Z M7.75,21.250129 L18.2884782,21.250129 C18.9117824,21.2570944 19.4450165,20.8038455 19.5386642,20.1863285 L20.9184928,11.1874519 C20.9735278,10.8248615 20.8665535,10.4563949 20.6259044,10.1796484 C20.3852552,9.90290183 20.0352126,9.74579901 19.66,9.75 L14,9.75 C13.5857864,9.75 13.25,9.41421356 13.25,9 L13.25,5 C13.25,3.91710661 12.4849943,3.01288988 11.4659366,2.79830349 L7.75,11.1591608 L7.75,21.250129 L7.75,21.250129 Z"
  }));
};
export default SvgThumbsUp;